const video_playlist_el = document.querySelectorAll('[id^="video_playlist_"]');

video_playlist_el.forEach(el => {
  let playlist_swiper = new Swiper('#' + el.id + ' .sidebar-wrapper .swiper-container', {
    direction: 'vertical',
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    // freeMode: true,
    // threshold: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    // mousewheel: true,
    touchStartPreventDefault: false,
    touchEventsTarget: 'wrapper',
    threshold: 1000,
    navigation: {
      nextEl: '#' + el.id + ' .sidebar-wrapper .swiper-button-next',
      prevEl: '#' + el.id + ' .sidebar-wrapper .swiper-button-prev',
    }
  });

  let video_swiper = new Swiper('#' + el.id + ' .slider-wrapper .swiper-container', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: playlist_swiper
    },
    on: {
      slideChange: function(el) {
        let command,
            index = el.previousIndex,
            slide = el.slides[index],
            type = slide.getAttribute('data-type'),
            iframe = slide.querySelectorAll('iframe')[0];
            video = slide.querySelectorAll('video')[0];

        if (type == 'vimeo') {
          command = {
            'method': 'unload',
            'value': 'true'
          };
        } else if (type == 'youtube') {
          command = {
            'event': 'command',
            'func': 'stopVideo'
          };
        } else {
          video.load();
        }

        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify(command), "*");
        }
      }
    }
  });
});